import React from 'react';

// Internals
import { TODO } from '../../types';
import Typography from '../../components/Typography';
import { truncate } from '../../utils';

// Hooks
import useProviders from '../../utils/useProviders';

// Antd
import { Avatar, Dropdown, Input, List, Menu, PageHeader, Skeleton, message, Spin } from 'antd';

// Icons
import { Download, MoreVertical, Search, Trash } from 'react-feather';

// Firebase
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../services/firebase';
import { get } from 'lodash-es';

// MISC
import { formatDistance } from 'date-fns';

export default function ConnectedAccounts() {
  const { getImageUsingID } = useProviders();

  const [user, loading, error] = useAuthState(auth);
  const [apiData, setApiData] = React.useState<Array<any> | null>(null);

  React.useEffect(() => {
    if (user && get(user, 'accessToken')) {
      fetch(process.env.REACT_APP_API_URL + '/accounts', {
        headers: new Headers({
          Authorization: 'Basic ' + (user as any).accessToken,
          'Content-Type': 'application/json',
        }),
      })
        .then((response) => response.json())
        .then(({ data }) => {
          setApiData(data);
        })
        .catch((e) => {
          console.log(e);

          message.error('Something went wrong');
        });
    }
  }, []);

  return (
    <>
      <PageHeader
        ghost={false}
        title={
          <>
            <Typography type="text_lg" weight="medium">
              Integrations and connected accounts
            </Typography>

            <Typography type="text_sm" color="secondary">
              Supercharge your accounting and finances by connecting the tools you use every day.
            </Typography>
          </>
        }
        extra={[<Input placeholder="Search..." prefix={<Search />} size="large" />]}
        style={{ margin: '0.5rem 0 1rem 0' }}
      />

      <Spin spinning={apiData === null}>
        {Array.isArray(apiData) && (
          <List
            className="demo-loadmore-list"
            itemLayout="horizontal"
            dataSource={apiData}
            renderItem={(item: TODO, index) => (
              <List.Item
                actions={[
                  <Dropdown
                    overlay={
                      <Menu>
                        <Menu.Item icon={<Download />} onClick={() => message.info('Coming soon')}>
                          Refresh
                        </Menu.Item>

                        <Menu.Item
                          icon={<Trash />}
                          onClick={() => message.info('Coming soon')}
                          style={{ color: '#F04438' }}
                        >
                          Delete
                        </Menu.Item>
                      </Menu>
                    }
                    placement="bottomLeft"
                  >
                    <a>
                      <MoreVertical style={{ fontSize: '1.5rem' }} />
                    </a>
                  </Dropdown>,
                ]}
              >
                <Skeleton avatar title={false} loading={item.loading} active>
                  <List.Item.Meta
                    avatar={<Avatar size={45} src={getImageUsingID(item.provider)} />}
                    title={
                      <Typography type="text_sm" weight="medium">
                        {item.name}
                      </Typography>
                    }
                    description={
                      <Typography type="text_sm" color="secondary">
                        {truncate(item.address)}
                      </Typography>
                    }
                  />

                  <div>{formatDistance(new Date(item.createdAt), new Date())} ago</div>
                </Skeleton>
              </List.Item>
            )}
          />
        )}
      </Spin>
    </>
  );
}
